import { useEffect, useState } from "react";

import { faMessages } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/design-system/Icon";
import {
  toggleWebchatWidget,
  WEBCHAT_SCRIPT_LOADED_EVENT,
  WEBCHAT_WINDOW_TOGGLE_EVENT,
} from "src/utils/useBootWebchat";

export const WebchatButton: React.FC<{ dataLoc?: string }> = ({ dataLoc }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleLoaded = (e: Event) => {
      setIsLoaded(true);
    };

    const handleToggle = (e: Event) => {
      const customEvent = e as CustomEvent<{ isOpen: boolean }>;
      setIsOpen(customEvent.detail.isOpen);
    };

    document.addEventListener(WEBCHAT_SCRIPT_LOADED_EVENT, handleLoaded);
    document.addEventListener(WEBCHAT_WINDOW_TOGGLE_EVENT, handleToggle);

    return () => {
      document.removeEventListener(WEBCHAT_SCRIPT_LOADED_EVENT, handleLoaded);
      document.removeEventListener(WEBCHAT_WINDOW_TOGGLE_EVENT, handleToggle);
    };
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <div
      className="fixed bottom-5.5 left-2.5 z-50 mt-auto flex justify-start"
      data-loc={dataLoc}
    >
      <div
        className={twJoin(
          "flex items-center justify-center overflow-hidden",
          "h-8 w-8",
          "shadow-sm",
          "rounded-full border border-gray-200 bg-white",
          "cursor-pointer transition-all duration-300 hover:scale-105",
          isOpen && "scale-105",
        )}
        onClick={(e) => {
          e.stopPropagation();
          toggleWebchatWidget();
        }}
      >
        <Icon icon={faMessages} size="sm" />
      </div>
    </div>
  );
};
